import { Component, Input } from '@angular/core';
import { IAlertHistoryModel, IAlertModel } from '@shared/models/alerts/alerts.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { animate, style, transition, trigger } from '@angular/animations';
import { iconTypeMap } from '@types-custom/models/ui/notifications-panel-model';
import { IRendererModel } from '@types-custom/models/ui/renderer.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IGridTableCellDispatcher, IGridTableHeaderModel } from '@types-custom/models/ui/grid-table-model';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'sit-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
  animations : [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('350ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }), // Agregando el estilo inicial de opacidad
        animate('350ms ease-in-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class NotificationCardComponent {
  @Input() Notification: IAlertHistoryModel | undefined
  protected readonly Icon = Icon;
  protected readonly iconTypeMap = iconTypeMap;

  //--------------

  @Input() headers: IGridTableHeaderModel[] = [];
  @Input() dataSource: Observable<[]> | undefined;

  constructor(
    private sanitizer: DomSanitizer
  ) {}

  dataCellType = {
    isNumber: (data: any) => typeof data === 'number',
  };

  hasDispatcher = (): boolean => this.headers.some(h => h.dispatcher);

  handleCardAction(item: any, index: number): void {
    const actionDispatcher = this.headers.find(header => header.dispatcher)?.dispatcher;
    if (actionDispatcher) {
      const actionData = { row: item, index };
      actionDispatcher.next(actionData);
    }
  };

  handleClick(
    dispatcher: Subject<IGridTableCellDispatcher> | undefined,
    row: any,
    key: string | undefined,
    index: number
  ): void {
    if (dispatcher) {
      const data = {
        row,
        index,
        key,
      };

      dispatcher.next(data);
    }
  }

  resolveRenderData(
    toRender: IRendererModel,
    cellData: any,
    key: string,
    index: number,
    row: any
  ): IRendererModel {
    const { component, data } = toRender;
    const renderModel = {
      component,
      data: data ? {
        ...data, props: {
          index: index,
          key: key,
          row: row,
        }, [key]: cellData
      } : { [key]: cellData },
    };
    return renderModel;
  }

  getFormattedText(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

}
